import { createApp } from 'vue';
import FeedbackModalVue from './feedback-modal.vue';
import { waitForBootstrap } from '../../bootstrap-helpers';

export class FeedbackModal {
    constructor(el, options) {
        this.props = options;
        this.init(el);
    }

    init(el) {
        const app = createApp(FeedbackModalVue, this.props);
        waitForBootstrap(() => app.mount(el));
    }
}
